import React from "react";
import banner from '.././assets/images/banner1.png';

function Banner(){
    return(
        <div className="banner" style={{backgroundImage: `url(${banner})`,}}>
            <div className="overlay"></div>
            <h1>Affiliate program</h1>
        </div>
    )
}

export default Banner